
import { watch, defineComponent, PropType, inject, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Store from './store'
import { ElMenuItem, ElSubmenu } from 'element-plus'
import { MenuItemType } from '../LayoutType'
import vuex from '@/store'
import Vuex from '@/store'
export default defineComponent({
  components: { ElMenuItem, ElSubmenu },
  props: {
    submenu: {
      type: Object as PropType<MenuItemType>,
      default: () => {
        return {}
      },
    },
    index: String,
  },
  name: 'SubMenu',
  setup(props, ctx) {
    const menu_isCollapse = computed(() => Vuex.state.leftMenuCollapse)
    const route = useRoute()
    const router = useRouter()
    watch(
      () => props.index,
      (e) => {
        const submenu = props.submenu as MenuItemType
        if (route.fullPath === submenu.url) {
          Store.store.defaultActive = e as string
        }
      },
      {
        immediate: true,
        deep: true,
      },
    )

    function openUrl(submenu: MenuItemType) {
      if (submenu?.url) {
        Store.store.defaultActive = submenu.key as string
        // 判断当前页面是否已存在tab标签
        const tabsKeyArr = vuex.state.tabsArr.map((item) => item.name)
        if (!tabsKeyArr.includes(`${submenu.title}&${submenu.key}`)) {
          vuex.state.tabsArr.push({
            key: submenu.key,
            name: `${submenu.title}&${submenu.key}`,
            url: submenu.url,
            parentKey: submenu.parentKey,
            child: submenu.child,
          })
          const newTabsArr = vuex.state.tabsArr
          vuex.commit('set_data', {
            tabsArr: newTabsArr,
          })
        }
        vuex.commit('set_data', {
          activeTabName: `${submenu.title}&${submenu.key}`,
          currentMicroDom: submenu.url,
          leftMenuCollapse: true,
        })
        // 哈希模式
        router.push({ path: submenu.url })
        // history.pushState('', '', submenu.url)
      }
    }

    return {
      openUrl,
      menu_isCollapse,
    }
  },
})
